import { apiPaths } from '@core/http/apiPaths';
import { httpClient } from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { SurveyCloneAPIModel, SurveyDetailsModel } from '@models/Surveys';

interface GetSurveyDetailsParams {
  surveyId: string;
  accountId: string;
}
export const getSurveyDetails = createAsyncThunk(
  `${EntityReducers.surveys}/getDetails`,
  async ({ surveyId, accountId }: GetSurveyDetailsParams, thunkApi) => {
    try {
      const response: AxiosResponse<SurveyDetailsModel> = await httpClient.get(
        apiPaths.surveys.surveyDetails({ surveyId }),
        {
          params: {
            accountId,
          },
        }
      );
      return response.data;
    } catch (err) {
      return thunkApi.rejectWithValue(err);
    }
  }
);

//

interface CloneSurveyParams extends SurveyCloneAPIModel {
  surveyId: string;
  dmaAccountId: number;
}

interface CloneSurveyResponse {
  id: string;
}

export const cloneSurvey = createAsyncThunk<CloneSurveyResponse, CloneSurveyParams>(
  `${EntityReducers.surveys}/cloneSurvey`,
  async ({ surveyId, ...data }: CloneSurveyParams, thunkApi) => {
    try {
      const response: AxiosResponse<string> = await httpClient.put(apiPaths.surveys.surveyClone({ surveyId }), {
        ...data,
      });
      return { id: response.data };
    } catch (err) {
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const surveysThunks = {
  getSurveyDetails,
  cloneSurvey,
};
